import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useEffect } from "react";
import { isCustomize } from "../utils";
import { preDecisionGatewayIsHiddenDueLegal, preDecisionGatewayIsPreventPreDecision, preDecisionGatewayIsDoNotTrack, preDecisionGatewayUserConsent, preDecisionGatewayIsCrawler, applyCookies } from "../others";
import { BANNER_PRE_DECISION_SHOW_EVENT } from "../types";

/**
 * Do some decision gateways like DNT, Bot / Crawler and Decision and depending
 * on that, show the Banner initially.
 */
function useBannerPreDecisionGateway(banner, setContextValue, toggleOverlay) {
  // Only run this predecision mechanism once and when not in customize
  !isCustomize() && useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var onSave, groups, essentialGroup, _groups$filter, _groups$filter2, essentialGroupObj, gateways, show, _i, _gateways, gateway, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onSave = banner.onSave, groups = banner.groups, essentialGroup = banner.essentialGroup;
              _groups$filter = groups.filter(function (_ref2) {
                var slug = _ref2.slug;
                return slug === essentialGroup;
              }), _groups$filter2 = _slicedToArray(_groups$filter, 1), essentialGroupObj = _groups$filter2[0];
              gateways = [preDecisionGatewayIsHiddenDueLegal, preDecisionGatewayIsPreventPreDecision, preDecisionGatewayIsCrawler, preDecisionGatewayIsDoNotTrack, preDecisionGatewayUserConsent];
              show = true;
              _i = 0, _gateways = gateways;

            case 5:
              if (!(_i < _gateways.length)) {
                _context.next = 17;
                break;
              }

              gateway = _gateways[_i];
              _context.next = 9;
              return gateway(banner);

            case 9:
              result = _context.sent;

              if (!(result !== false)) {
                _context.next = 14;
                break;
              }

              show = false;

              if (result === "all") {
                applyCookies("all");
              } else if (result === "dnt") {
                // Accept only essentials (save because they are always preselected when no decision given and we need to hold this decision in API)
                onSave(gateway === preDecisionGatewayIsDoNotTrack, "none");
              } else if (result === "consent") {
                // Apply cookies for the current user decision
                applyCookies("consent");
              }

              return _context.abrupt("break", 17);

            case 14:
              _i++;
              _context.next = 5;
              break;

            case 17:
              // No gateway passed, let's show the banner!
              if (show) {
                setContextValue(function (state) {
                  return _objectSpread(_objectSpread({}, state), {}, {
                    // Always revert back to "Essentials" only consent when cookie needs to be consented
                    consent: {
                      groups: _defineProperty({}, essentialGroupObj.id, essentialGroupObj.items.map(function (_ref3) {
                        var id = _ref3.id;
                        return id;
                      }))
                    }
                  }, toggleOverlay(state, true));
                }); // All content blockers should be made visible

                document.dispatchEvent(new CustomEvent(BANNER_PRE_DECISION_SHOW_EVENT, {
                  detail: {}
                }));
              }

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);
}

export { useBannerPreDecisionGateway };